import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
    paddingTop: theme.spacing(1),
  },
  scrollableContainer: {
    maxHeight: '588px',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: theme.spacing(3),
    marginRight: theme.spacing(-2.5),
    // Webkit browsers (Chrome, Safari, Edge)
    '&::-webkit-scrollbar': {
      width: theme.spacing(1),
      height: theme.spacing(1),
      WebkitAppearance: 'none',
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
      borderRadius: theme.spacing(0.5),
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.select.hover,
      borderRadius: theme.spacing(0.5),
      minHeight: theme.spacing(6.75),
    },
    // Firefox
    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.palette.select.hover} transparent`,
  },
  currency: {
    color: theme.palette.labraText.description,
    lineHeight: '20px',
    fontSize: '14px',
  },
  amount: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'end',
  },
  titleRight: {
    display: 'flex',
    width: '100%',
    justifyContent: 'right',
  },
  textAlignRight: {
    textAlign: 'right',
  },
}))
